import { render } from "./ShueishaOnlineProfile.vue?vue&type=template&id=1adc0b3c&scoped=true&ts=true"
import script from "./ShueishaOnlineProfile.vue?vue&type=script&lang=ts"
export * from "./ShueishaOnlineProfile.vue?vue&type=script&lang=ts"

import "./ShueishaOnlineProfile.vue?vue&type=style&index=0&id=1adc0b3c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1111083459/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1adc0b3c"]])

export default __exports__